import { Row } from 'antd';
import styled from 'styled-components';
export const Header = styled.div`
  display: flex;
  font-size: 1.25rem;
  font-weight: 500;
`;
export const Container = styled.div`
  display: flex;
  flex-direction: column;
`;
export const Deemphasized = styled.p`
  color: #8c8c8c;
  font-size: 0.75rem;
`;
export const DetailRows = styled(Row)`
  justify-content: space-between;
  width: 70%;
`;